import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const startIntake = () => api.post("/intake/start").then((r) => r.data);

export const sendMessage = (session_id, text) =>
  api.post("/intake/message", { session_id, text }).then((r) => r.data);

export const generateReport = (session_id, email, name) =>
  api
    .post(
      "/intake/generate-report",
      { session_id, email, name },
      { timeout: 30000 } // quick ack — actual generation runs in background
    )
    .then((r) => r.data);

export const getReportStatus = (session_id) =>
  api.get(`/intake/report-status/${session_id}`, { timeout: 15000 }).then((r) => r.data);

export const getReport = (session_id) =>
  api.get(`/intake/report/${session_id}`).then((r) => r.data);

export const reportPdfUrl = (session_id) =>
  `${API}/intake/report/${session_id}/pdf`;

export const adminLogin = (password) =>
  api.post("/admin/login", { password }).then((r) => r.data);

export const adminIntakes = (token) =>
  api.get("/admin/intakes", { headers: { "X-Admin-Token": token } }).then((r) => r.data);

export const adminIntakeDetail = (token, id) =>
  api.get(`/admin/intakes/${id}`, { headers: { "X-Admin-Token": token } }).then((r) => r.data);

export const adminDeleteIntake = (token, id) =>
  api.delete(`/admin/intakes/${id}`, { headers: { "X-Admin-Token": token } }).then((r) => r.data);
